import { render, staticRenderFns } from "./deleteHousekeepingServUser.vue?vue&type=template&id=156af00a"
import script from "./deleteHousekeepingServUser.vue?vue&type=script&lang=js"
export * from "./deleteHousekeepingServUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports